parentStoreObject